import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const TabsContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.md')};
`;
export const TabButton = styled.button `
  display: flex;
  align-items: center;

  padding: ${themeGet('spacing.sm')} ${themeGet('spacing.md')};

  border-radius: ${themeGet('borderRadius.md')};
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;

  color: ${themeGet('colors.text.100')};
  font-size: ${themeGet('fontSize.small')};

  transition: all 175ms ease-in-out;

  &:hover:not([data-active='true']) {
    color: ${themeGet('colors.text.200')};
    background-color: ${themeGet('colors.background.75')};
  }

  ${(props) => props.$active &&
    `
    color: ${themeGet('colors.text.300')};
    background-color: ${themeGet('colors.background.100')};
  `}
`;
